import { SITE } from "@/common/seo.config";
import {
  buildBreadcrumbList,
  buildFaqPage,
  buildServiceSchema,
  buildWebPage,
  pageSchemas,
} from "@/lib/schema";

export function buildServicePageSchema({
  config,
  path,
  faqs = [],
  serviceName,
  serviceType,
}) {
  const name = serviceName || config.pageTitle;
  const description = config.pageDescription;
  return pageSchemas([
    buildWebPage({
      path,
      name,
      description,
    }),
    buildServiceSchema({
      name,
      description,
      path,
      serviceType: serviceType || name,
    }),
    buildFaqPage(faqs, { id: `${SITE.siteUrl}${path}#faq` }),
    buildBreadcrumbList([
      { name: "Home", path: "/" },
      { name: name, path },
    ]),
  ]);
}
